import styled, { css } from 'styled-components';
var SizeOption = styled.a.withConfig({
  displayName: "UnitPickerstyles__SizeOption",
  componentId: "sc-1y5sa8d-0"
})(["padding:12px 10px;display:inline-block;min-width:40px;text-align:center;border:3px solid ", ";background:", ";color:", ";", ""], function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.active && css(["color:", ";background:", ";"], props.theme.color.monochrome.white, props.theme.color.monochrome.darker);
});
var SizeOptionLabel = styled.p.withConfig({
  displayName: "UnitPickerstyles__SizeOptionLabel",
  componentId: "sc-1y5sa8d-1"
})(["display:flex;align-items:center;"]);
export { SizeOption, SizeOptionLabel };